import makeTypeCreator from '@/models/makeTypeCreator'

const createType = makeTypeCreator('conversations')

export const ADD_CONVERSATION = createType('ADD_CONVERSATION')
export const FETCH_CONVERSATIONS = createType('FETCH_CONVERSATIONS')
export const NAV_TO_CONVERSATION = createType('NAV_TO_CONVERSATION')
export const NAV_TO_ORDER_CONV = createType('NAV_TO_ORDER_CONV')
export const CONVERSATIONS_FETCHED = createType('CONVERSATIONS_FETCHED')
export const TOGGLE_PINNED = createType('TOGGLE_PINNED')
export const CONVERSATION_UPDATED = createType('CONVERSATION_UPDATED')
export const PINNED_CHANGE = createType('PINNED_CHANGE')
export const HOIST_CONV = createType('HOIST_CONV')
export const MARK_READ = createType('MARK_READ')
export const MARK_READ_SUCCESS = createType('MARK_READ_SUCCESS')
export const REMOVE_CONVERSATION = createType('REMOVE_CONVERSATION')
export const QUERY_CONV_STATS = createType('QUERY_CONV_STATS')
export const CONV_STATS_FETCHED = createType('CONV_STATS_FETCHED')
export const RESET_CONVS = createType('RESET_CONVS')


